// extracted by mini-css-extract-plugin
export default {"container":"ProductInfo_container__KW373","txt":"ProductInfo_txt__xdUZB"};